export const SITE_DOCUMENTS_LIST_REQUEST = "SITE_DOCUMENTS_LIST_REQUEST";
export const SITE_DOCUMENTS_LIST_SUCCESS = "SITE_DOCUMENTS_LIST_SUCCESS";
export const SITE_DOCUMENTS_LIST_FAIL = "SITE_DOCUMENTS_LIST_FAIL";

export const SITE_DOCUMENT_UPSERT_REQUEST = "SITE_DOCUMENT_UPSERT_REQUEST";
export const SITE_DOCUMENT_UPSERT_SUCCESS = "SITE_DOCUMENT_UPSERT_SUCCESS";
export const SITE_DOCUMENT_UPSERT_FAIL = "SITE_DOCUMENT_UPSERT_FAIL";

export const SITE_DOCUMENT_DELETE_REQUEST = "SITE_DOCUMENT_DELETE_REQUEST";
export const SITE_DOCUMENT_DELETE_SUCCESS = "SITE_DOCUMENT_DELETE_SUCCESS";
export const SITE_DOCUMENT_DELETE_FAIL = "SITE_DOCUMENT_DELETE_FAIL";
